import { DEFAULT_METRICS_SETTINGS } from "src/components";
import { IMetricsSettings, useSettings } from "src/hooks";

const useTeamMetricsSettings = (teamSlug: string) => {
  const {
    teamMetricsSettings: { [teamSlug]: unsafeSettings },
    updateTeamMetricsSettings,
  } = useSettings();

  const safeSettings: IMetricsSettings = {
    ...DEFAULT_METRICS_SETTINGS,
    ...unsafeSettings,
  };

  return {
    settings: safeSettings,
    updateSettings: (updatedSettings: Partial<IMetricsSettings>) => {
      updateTeamMetricsSettings(teamSlug, updatedSettings);
    },
  };
};

export { useTeamMetricsSettings };
